module.exports = "<div data-bind=\"attr: {'data-field': field}, css: {'u-col-6': size != 'lg', 'u-col-10': size == 'lg'}\" class=bie-item> <div data-bind=\"css: {'u-col-4': size != 'lg', 'u-col-1_5': size == 'lg'}\" class=\"bie-label text-right\"> <span data-bind=\"text: displayName, css: {'bie-required': required}\"></span> </div> <div data-bind=\"css: {'u-col-8': size != 'lg', 'u-col-4_5': size == 'lg'}\"> <span data-bind=\"text: text, css: {'outerdata': outerData}\" class=bie-span></span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/ag-form/form-span/index.html
// module id = 116
// module chunks = 144